// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
.switch {
    position: relative;
    display: inline-block;
    width: 38px;
    height: 18px;
    margin-left: 20px;
}

.switch input {
    opacity: 0;
    width: 0;
    height: 0;
}

.slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #9e9e9e;
    -webkit-transition: .4s;
    transition: .4s;
}

.slider:before {
    position: absolute;
    content: "";
    height: 20px;
    width: 20px;
    left: 0;
    bottom: -1px;
    box-shadow: 0 1px 2px #9e9e9e;
    background-color: white;
    -webkit-transition: .4s;
    transition: .4s;
}

input:checked + .slider {
    background-color: #004ba080;
}

input:focus + .slider {
    box-shadow: 0 0 1px #004ba0;
}

input:checked + .slider:before {
    -webkit-transform: translateX(18px);
    -ms-transform: translateX(18px);
    transform: translateX(18px);
    background-color: #004ba0;
}

!* Rounded sliders *!
.slider {
    border-radius: 20px;
}

.slider:before {
    border-radius: 50%;
}*/
`, "",{"version":3,"sources":["webpack://./src/app/dashboard/css/switch.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA8DE","sourcesContent":["/*\n.switch {\n    position: relative;\n    display: inline-block;\n    width: 38px;\n    height: 18px;\n    margin-left: 20px;\n}\n\n.switch input {\n    opacity: 0;\n    width: 0;\n    height: 0;\n}\n\n.slider {\n    position: absolute;\n    cursor: pointer;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: #9e9e9e;\n    -webkit-transition: .4s;\n    transition: .4s;\n}\n\n.slider:before {\n    position: absolute;\n    content: \"\";\n    height: 20px;\n    width: 20px;\n    left: 0;\n    bottom: -1px;\n    box-shadow: 0 1px 2px #9e9e9e;\n    background-color: white;\n    -webkit-transition: .4s;\n    transition: .4s;\n}\n\ninput:checked + .slider {\n    background-color: #004ba080;\n}\n\ninput:focus + .slider {\n    box-shadow: 0 0 1px #004ba0;\n}\n\ninput:checked + .slider:before {\n    -webkit-transform: translateX(18px);\n    -ms-transform: translateX(18px);\n    transform: translateX(18px);\n    background-color: #004ba0;\n}\n\n!* Rounded sliders *!\n.slider {\n    border-radius: 20px;\n}\n\n.slider:before {\n    border-radius: 50%;\n}*/\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
